<template>
        <span v-if="!compList.length">
            -
        </span>
        <span v-else-if="compList.length == 1">
            <span class="text-primary cursor-pointer" :title="compList[0].title" @click="()=>onOpen(compList[0])">
                {{ compList[0].number || compList[0].inv_number || "Concept"}} 
            </span>
        </span>
        <DropMenu v-else>
            <template v-slot:trigger="{ on }">
                <span class="text-primary cursor-pointer" v-on="on">
                    <span>
                        {{ compList[0].number || compList[0].inv_number || "Concept"}} [+{{ compList.length - 1}}] 
                    </span>
                </span> 
            </template>
                <v-list dense class="py-0" >
                    <ActionMenuItem no-icon action="salesinvoice.open" v-for='(item, index) in compList' :key='index' class="text-primary cursor-pointer" @click="()=>onOpen(item)">
                        {{ item.number || item.inv_number || "Concept"}}
                    </ActionMenuItem>
                </v-list>
        </DropMenu>

</template>


<script setup>
    // Usage: 
    //   import InvoiceList from '@/features/salesinvoice/controls/InvoiceList'
    //
    //   <InvoiceList :list="model.workorders"></InvoiceList>

    import {computed, ref} from 'vue';
    import DropMenu from "@controls/menu/DropMenu.vue";
    import dlg from '@app/dlg'

    import ActionMenuItem from '@controls/menu/ActionMenuItem.vue'
    const props = defineProps({
        list: {
            type: [String, Array]
        },
    })

    const compList = computed({
        get() {
            var result = props.list || [];
            if (typeof result === 'string') {
                try {
                    result = JSON.parse(props.list) || [];
                } catch (e) {
                    console.error("Failed to parse invoice list:", e);
                    // ... and continue
                }
            }
            return result;
            //return [...result, ...result, ...result];
        }
    })

    function onOpen(item) {
        dlg.open('salesinvoice', {id: item.id_invoice});
    }

</script>
